import { render, staticRenderFns } from "./TextComponent.vue?vue&type=template&id=fce0be20&scoped=true"
import script from "./TextComponent.vue?vue&type=script&lang=js"
export * from "./TextComponent.vue?vue&type=script&lang=js"
import style0 from "./TextComponent.vue?vue&type=style&index=0&id=fce0be20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce0be20",
  null
  
)

export default component.exports